import './styles.scss'
import * as React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {VeboxDrawer} from "../../../users/components/VeboxDrawer";
import {CensusTopMenu} from "../CensusTopMenu";
import {CensusList} from "../CensusList";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {DataResponse} from "../../../processes/massive_actions/CensusCooler/data/models/RestApi";
import {
    JSONCensusAvailabilityCheckResult
} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensusAvailabilityCheckResult";
import {Display} from "../../../components/Display";
import {CensusListContext} from "../../providers/CensusListProvider";

declare var AppTranslations: AppTranslations;

interface CensusMenuProps {
    setLocation: (location: Location) => void;
    isCensusFeatureAvailable: DataResponse<JSONCensusAvailabilityCheckResult>
    updateNavigateToCensusDetail: (value: boolean) => void
}

export const CensusMenu: React.FC<CensusMenuProps> = ({
                                                          setLocation,
                                                          isCensusFeatureAvailable,
                                                          updateNavigateToCensusDetail
                                                      }) => {
    const {isFetching, error, totalCount} = React.useContext(CensusListContext);
    const [open, setOpen] = React.useState<boolean>();
    const location = useLocation();
    const navigate = useNavigate();

    const toggle = () => {
        updateNavigateToCensusDetail(false)
        navigate("/");
    }

    React.useEffect(() => {
        setOpen(location.pathname === "/");
        setLocation(location as unknown as Location)
    }, [location]);

    return (
        <VeboxDrawer
            className={"side-menu list-menu"}
            header={<h1>{AppTranslations.massiveActions.censusCooler.titlePlural}</h1>}
            onToggle={toggle}
            open={open}
            closable={false}
            closedHeader={
                <Display isVisible={!isFetching}>
                    <p className="closed-header-title">
                        {AppTranslations.massiveActions.censusCooler.listOfAccessibleCensus.replace('{0}',
                            (!error && totalCount ? totalCount : 0).toString())}
                    </p>
                </Display>}
        >
            <CensusTopMenu isCensusFeatureAvailable={isCensusFeatureAvailable}/>
            <CensusList/>
        </VeboxDrawer>
    );
}